module.exports = __webpack_public_path__ + "img/home-clothing2.ab517929.png";